import { FC } from 'react';
import { Typography } from 'antd';
import { formatDateTime } from '../../utils/dateFormat';

const { Text } = Typography;

interface TimeDisplayProps {
  /**
   * 时间值
   */
  value: string | number | Date;
  /**
   * 自定义样式
   */
  style?: React.CSSProperties;
  /**
   * 文本类型
   */
  type?: 'secondary' | 'success' | 'warning' | 'danger';
  /**
   * 占位符文本（当值为空时显示）
   */
  placeholder?: string;
  /**
   * 是否显示秒
   */
  showSeconds?: boolean;
  /**
   * 是否显示日期
   */
  showDate?: boolean;
  /**
   * 是否显示时间
   */
  showTime?: boolean;
}

const TimeDisplay: FC<TimeDisplayProps> = ({
  value,
  style,
  type,
  placeholder = '-',
  showSeconds = true,
  showDate = true,
  showTime = true
}) => {
  if (!value) {
    return <Text type={type} style={style}>{placeholder}</Text>;
  }

  const displayText = formatDateTime(value, {
    showSeconds,
    showDate,
    showTime
  });

  return (
    <Text type={type} style={style}>
      {displayText}
    </Text>
  );
};

export default TimeDisplay; 